export class Lead {
	static STATES: any[] = [
		{ value: "open", title: "Öppen", badge: "primary" },
		{ value: "closed", title: "Stängd", badge: "dark" },
	];
}
